"use client";

import { Children, useEffect, useState, type ReactNode } from "react";

// Step 9 commit 15 (Lighthouse TBT): mounting ~100 interactive product
// cards in one hydration pass produces an 800ms+ long task on mobile.
// This wrapper server-renders only the first chunk, then mounts the
// rest in small post-hydration chunks - each chunk is its own task
// under the 50ms long-task threshold, so total blocking time drops to
// near zero while the full grid is still present well under a second
// after load. Opt-in (dashboard catalog only): the public catalog
// keeps full SSR so crawlers see every card's internal links.
const INITIAL_COUNT = 12;
const CHUNK_SIZE = 6;

export function ProgressiveGridItems({ children }: { children: ReactNode }) {
  const items = Children.toArray(children);
  const [count, setCount] = useState(INITIAL_COUNT);

  useEffect(() => {
    if (count >= items.length) return;
    const id = window.setTimeout(() => {
      setCount((c) => c + CHUNK_SIZE);
    }, 0);
    return () => window.clearTimeout(id);
  }, [count, items.length]);

  return <>{items.slice(0, count)}</>;
}
